import PropTypes from "prop-types";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { getTranscriptRequestFailureMessage } from "components/CallTranscript/transcriptUnavailability";
import callConstants from "constants/Call";

const QUEUED = callConstants.TRANSCRIPT_REQUEST_OUTCOMES.QUEUED;

function summary(queued, rejectedCount) {
  const queuedPart = queued === 1 ? "1 call queued" : `${queued} calls queued`;
  const rejectedPart =
    rejectedCount === 1 ? "1 could not be" : `${rejectedCount} could not be`;
  return `${queuedPart}. ${rejectedPart}.`;
}

/**
 * What a manual transcription request did, for the calls it could not queue.
 *
 * Only rejections are listed: a row per queued call says nothing the count at
 * the top does not. Call context comes from the table rows captured when the
 * request was sent, because the response carries ids alone.
 */
export function TranscriptionRequestResultsDialog({
  open,
  onOpenChange,
  queued = 0,
  minimumDurationSeconds,
  results = [],
  callsById = {},
}) {
  const rejected = results.filter(result => result.outcome !== QUEUED);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="tw:sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Transcription Requests</DialogTitle>
          <DialogDescription>
            {summary(queued, rejected.length)}
          </DialogDescription>
        </DialogHeader>
        <div className="tw:max-h-[60vh] tw:overflow-y-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Call</TableHead>
                <TableHead>Contact</TableHead>
                <TableHead>Reason</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rejected.map(result => (
                <TableRow key={result.call_id}>
                  <TableCell>{result.call_id}</TableCell>
                  <TableCell>
                    {callsById[result.call_id]?.contact_full_name ?? "—"}
                  </TableCell>
                  <TableCell>
                    {getTranscriptRequestFailureMessage({
                      outcome: result.outcome,
                      transcriptStatus: result.transcript_status,
                      minimumDurationSeconds,
                    })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
}

TranscriptionRequestResultsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  queued: PropTypes.number,
  minimumDurationSeconds: PropTypes.number,
  results: PropTypes.array,
  callsById: PropTypes.object,
};

export default TranscriptionRequestResultsDialog;
